import { render, staticRenderFns } from "./tyStatistics.vue?vue&type=template&id=8cf15a90&scoped=true"
import script from "./tyStatistics.vue?vue&type=script&lang=js"
export * from "./tyStatistics.vue?vue&type=script&lang=js"
import style0 from "./tyStatistics.vue?vue&type=style&index=0&id=8cf15a90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf15a90",
  null
  
)

export default component.exports